<div class="download">
  <div class="content">
    <app-advisor-image *ngIf="pdfIcon" path="/all/pdf.svg"></app-advisor-image>
    <div class="download-teaser">
      <h2 [innerHTML]="textkeyPrefix + 'download.headline' | translate"></h2>
      <p *ngIf="!imageUrl" class="cell small-12" [innerHTML]="textkeyPrefix + 'download.teaser' | translate"></p>
    </div>
    <div *ngIf="imageUrl" class="grid-x">
      <div class="cell small-12 medium-6">
        <div class="image-wrapper">
          <app-advisor-image [path]="imageUrl"></app-advisor-image>
          <span class="copyright" [innerHTML]="textkeyPrefix + 'download.copyright' | translate"></span>
        </div>
      </div>
      <div class="cell small-12 medium-6">
        <p [innerHTML]="textkeyPrefix + 'download.teaser' | translate"></p>
      </div>
    </div>
  </div>
  <div class="cta-wrapper">
    <a [href]="url" class="button primary" target="_blank"><i class="icon-download" [attr.aria-label]="'arialabel.download.icon' | translate"></i><span [innerHTML]="textkeyPrefix + 'download.button' | translate"></span></a>
  </div>
</div>
